var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewResourceHr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200 -275) translate(0 120) translate(201 156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.78 46.373H12.814c0-7.077 5.873-12.814 13.118-12.814 4.914 0 9.197 2.64 11.444 6.545M19.525 18.915c3.795 3.586 8.406 4.655 13.424 2.685"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.627,
    cy: 23.492,
    rx: 7.932,
    ry: 7.627
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.78,
    cy: 52.78,
    r: 19.22,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M52.475 43.322L52.475 62.237M43.322 53.085L62.237 53.085M27.827 62.237H4.77C2.136 62.237 0 60.094 0 57.45V4.787C0 2.143 2.136 0 4.77 0h33.804c1.264.001 2.477.506 3.37 1.404l9.134 9.164c.895.898 1.397 2.116 1.397 3.386v13.973"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewResourceHr);
export default __webpack_public_path__ + "static/media/new-resource-hr.cb6abc474dfcdc2971092afc1b52a0d8.svg";
export { ForwardRef as ReactComponent };